import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="mx-auto flex w-full flex-col items-center justify-center px-4 py-24 text-center md:px-6">
      <p className="font-heading text-8xl font-black text-primary-100 md:text-[10rem]">404</p>
      <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-900">页面不存在</h1>
      <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-500">
        抱歉，你访问的页面可能已被移除、改名或暂时不可用。你可以返回首页继续浏览丰富的影视与视频内容。
      </p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-5-line" />
          返回首页
        </Link>
        <Link
          to="/category/movie"
          className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
        >
          <i className="ri-compass-3-line" />
          浏览分类
        </Link>
      </div>
    </div>
  );
}